import request from '@/utils/request'
const apiPath = '/temp/templateClassification'
import { downloadBlob } from '@/utils/download'
const templateClassificationApi = {
  /**
   * 新增【模版分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【模版分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【模版分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchTreeList(query) {
    return request.get(apiPath + '/backendTreeList', { params: query })
  },
  /**
   * 查询【模版分类】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【模版分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【模版分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量修改状态【模版分类】
   * @param {string} ids - id，以逗号隔开，如 "1,2,3"
   * @param {number} state - 1启用 0禁用
   */
  updateStateBatch(ids, state) {
    return request.post(`${apiPath}/updateStateBatch`, null, {
      params: {
        ids: ids,
        state: state
      }
      ,isFormData: 1
    })
  },
  /**
   * 单个修改状态【模版分类】（如果存在则保留，不存在则跳过）
   */
  setIsEnable(data) {
    return request.post(`${apiPath}/setIsEnable`, data)
  },
  /**
   * 批量修改状态【模版分类】（兼容旧方法名）
   */
  setIsEnableBatch(data) {
    const ids = Array.isArray(data.ids) ? data.ids.join(',') : data.ids
    return request.post(`${apiPath}/updateStateBatch`, null, {
      params: {
        ids: ids,
        state: data.state
      }
    })
  }
}
export default templateClassificationApi
